import { render, staticRenderFns } from "./TeamsCreateEdit.vue?vue&type=template&id=4beec72a&scoped=true&"
import script from "./TeamsCreateEdit.vue?vue&type=script&lang=js&"
export * from "./TeamsCreateEdit.vue?vue&type=script&lang=js&"
import style0 from "./TeamsCreateEdit.vue?vue&type=style&index=0&id=4beec72a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4beec72a",
  null
  
)

export default component.exports